import { render, staticRenderFns } from "./input-data.vue?vue&type=template&id=48457048"
import script from "./input-data.vue?vue&type=script&lang=js"
export * from "./input-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports